<template>
    <div v-if="verified == 'success'" class="flex flex-col content-center justify-center max-w-sm mx-auto mt-12 lg:w-full lg:max-w-md">
        <div class="flex justify-center text-4xl font-semibold text-gray-900">
            Email verified!
        </div>
        <div class="flex flex-col justify-center mt-12 mb-12 font-semibold text-gray-800 lg:flex-row">
            <div class="flex justify-center mt-2 mb-2 font-semibold text-gray-800">Awesome! Let's finish getting you set up!</div>
            <router-link
                to="/signup/checkout"
                tag="button"
                class="flex justify-center w-full px-3 py-3 font-bold tracking-tight text-white bg-gray-900 lg:ml-4 btn hover:bg-gray-800 focus:outline-none focus:shadow-outline"
            >
                Finish setup
                <svg class="w-6 h-6 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path
                        d="M14.5857864,13 L7,13 C6.44771525,13 6,12.5522847 6,12 C6,11.4477153 6.44771525,11 7,11 L14.5857864,11 L12.2928932,8.70710678 C11.9023689,8.31658249 11.9023689,7.68341751 12.2928932,7.29289322 C12.6834175,6.90236893 13.3165825,6.90236893 13.7071068,7.29289322 L17.7071068,11.2928932 C18.0976311,11.6834175 18.0976311,12.3165825 17.7071068,12.7071068 L13.7071068,16.7071068 C13.3165825,17.0976311 12.6834175,17.0976311 12.2928932,16.7071068 C11.9023689,16.3165825 11.9023689,15.6834175 12.2928932,15.2928932 L14.5857864,13 Z"
                    />
                </svg>
            </router-link>
        </div>
    </div>
    <div v-else-if="verified == 'error'" class="flex flex-col content-center justify-center max-w-sm mx-auto mt-12 lg:w-full lg:max-w-md">
        <div class="flex flex-col justify-center mt-12 mb-12 font-semibold text-gray-800 lg:flex-row">
            <div class="mt-2 mb-2 font-semibold text-gray-800">Hmm. Something went wrong when verifying your email.</div>
            <router-link to="/signup" tag="a" class="font-semibold text-blue-500 cursor-pointer">Back to signup</router-link>
        </div>
    </div>
    <div v-else class="flex flex-col content-center justify-center max-w-sm mx-auto mt-12 lg:w-full lg:max-w-md">
        <div class="flex flex-col justify-center mt-12 mb-12 font-semibold text-gray-800 lg:flex-row">
            <div class="mt-2 mb-2 font-semibold text-gray-800">Verifying your email...</div>
        </div>
    </div>
</template>
<script>
import api from '@/client';

export default {
    name: 'signup-email-confirm',
    data() {
        return {
            verified: 'loading',
        };
    },
    created() {
        localStorage.setItem('signup_org', this.$route.query.id);
        api('confirm', { params: { key: this.$route.query.key } }).then(response => {
            if (response.status === 200 || response === 201) {
                this.verified = 'success';
            } else {
                this.verified = 'error';
            }
        });
    },
};
</script>
